import { render, staticRenderFns } from "./documentsType.vue?vue&type=template&id=c73db7e2&scoped=true&"
import script from "./documentsType.vue?vue&type=script&lang=js&"
export * from "./documentsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73db7e2",
  null
  
)

export default component.exports